export const FILE_UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  MAX_FILES_COUNT: 10,
  CHUNK_SIZE: 1024 * 1024,
} as const;

export const ALLOWED_FILE_TYPES = {
  DOCUMENTS: ['.pdf', '.doc', '.docx'],
  SPREADSHEETS: ['.xls', '.xlsx'],
  IMAGES: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
  ALL: [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.webp',
  ],
} as const;

export const FILE_UPLOAD_STATUS = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
} as const;

// Utility function to format file size
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

// Utility function to validate file type
export const isValidFileType = (
  fileName: string,
  allowedTypes: readonly string[]
): boolean => {
  const fileExtension = '.' + (fileName.split('.').pop()?.toLowerCase() ?? '');
  return allowedTypes.includes(fileExtension);
};

// Utility function to generate unique file key
export const generateFileKey = (file: File): string => {
  return `${file.name}-${file.size}-${file.lastModified}`;
};
